import { country } from "@features/country/data";
import { isFirebaseFeatureEnabledSync } from "@features/feature-manager/data";
import user from "user";

export const isCpaCalculatorUserFeatureEnabled = () => {
  return country.isKSA && user.hasFeature("cpa_calculator");
};

export function isMarketplaceV3UserFeatureEnabled() {
  return user.hasFeature("market-place-notifications-lock-updates");
}

export function isMarketplaceUnallocatedQuantitiesFeatureEnabled() {
  return user.hasFeature("marketplace-lock-unallocated-quantities");
}

export function isMarketplaceV3FeatureEnabled() {
  return (
    isMarketplaceV3UserFeatureEnabled() &&
    isFirebaseFeatureEnabledSync("WEB_MARKETPLACE_V3")
  );
}

export function isMarketplaceV3_3FeatureEnabled() {
  return (
    isMarketplaceUnallocatedQuantitiesFeatureEnabled() &&
    isFirebaseFeatureEnabledSync("WEB_MARKETPLACE_V3_3")
  );
}

export function isMarketplaceV3_4FeatureEnabled() {
  return (
    isMarketplaceUnallocatedQuantitiesFeatureEnabled() &&
    isFirebaseFeatureEnabledSync("WEB_MARKETPLACE_V3_4")
  );
}

export function isDiscountsOnQuantityEnabled() {
  return isFirebaseFeatureEnabledSync("DISCOUNTS_ON_QUANTITY");
}

export function isOriginalPriceEnabled() {
  return isFirebaseFeatureEnabledSync("ORIGINAL_PRICE");
}
